<template>
  <div>
    <BaseTitle :title="$t('content.detail_quitionnaire')" />
    <form @submit.prevent="submit">
      <v-card class="d-flex  justify-space-between pa-5 mb-10">
        <div>
          <span class="text-quiz-bottom mb-2">Teacher </span> :
          <strong class="text-quiz-bottom mr-5"> {{ datas.teacherName }}</strong>
          |
          <span class="text-quiz-bottom mb-2 ml-4">Course </span> :
          <strong class="text-quiz-bottom mr-5"> {{ datas.courseName }}</strong>
        </div>
        <div>
          <span class="text-quiz-bottom mb-2">Due Date </span> :
          <strong class="text-quiz-bottom mr-5" style="color:#E02020;"> {{ datas.dueDate }}</strong>
        </div>
      </v-card>
      <strong class="text-quiz-bottom">Rate quitionnaire the teacher according to the learning you are experiencing</strong>
      <v-card class="mt-5">
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">Rate Quitionnaire</div>
        </div>
        <div class="pa-6">
          <v-row>
            <v-col md="12" v-for="(item, index) in datas.categories" :key="index">
              <form-group :name="item.categoryName" :validator="$v.datas.categories.$each.$iter[index].rate">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    type="number"
                    min="0"
                    v-model="item.rate"
                    v-bind="attrs"
                    :label="item.categoryName"
                    @blur="$v.datas.categories.$each.$iter[index].rate.$touch()"
                    @input="maximum($event, index)"
                    v-number
                    @paste="onPaste"
                  />
                </template>
              </form-group>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <div class="d-flex justify-end align-center mt-5">
        <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
        <v-btn color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{ $t('submit') }}</v-btn>
      </div>
      <!-- Dialog Success -->
      <v-dialog v-model="dialogPopUp" persistent max-width="800">
        <v-card>
          <div class="d-flex justify-center">
            <svg-icon icon="img-success" class="succ-featured pa-10" width="860" height="300" />
          </div>
          <v-card-title class="headline d-flex justify-center">Thank You!</v-card-title>
          <v-card-text class="d-flex justify-center">You have successfully to rate quitionnaire </v-card-text>
          <v-card-text class="d-flex justify-center">
            <v-btn color="primary" class="btn-primary-custom" @click="back()">
              {{ $t('close') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import { required, numeric } from 'vuelidate/lib/validators';

export default {
  name: 'detailQuitionaire',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({})
  },
  validations() {
    return {
      datas: {
        categories: {
          $each: {
            rate: { required, numeric }
          }
        }
      }
    };
  },
  data: () => ({
    loading: false,
    dialogPopUp: false,
    datas: {
      analyticalQuitionnaireId: '',
      teacherName: '',
      courseName: '',
      dueDate: '',
      categories: []
    }
  }),
  methods: {
    onPaste(evt) {
      if (evt) {
        evt.preventDefault();
      }
    },
    maximum(e, index) {
      if (Number(e) >= Number(this.datas.categories[index].valueMax)) {
        this.$nextTick(() => {
          this.datas.categories[index].rate = this.datas.categories[index].valueMax;
        });
      }
      this.$v.datas.categories.$each.$iter[index].rate.$touch();
    },
    getData() {
      this.$store
        .dispatch('Analytical/getQuizStudentTeacher', this.$route.params.id)
        .then(res => {
          res.categories.forEach(data => (data.rate = ''));
          this.datas = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      const payload = { payload: this.datas.categories, analyticalQuitionnaireId: this.datas.analyticalQuitionnaireId };

      this.$store
        .dispatch(`Analytical/fillTeacher`, payload)
        .then(data => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.dialogPopUp = true;
        })
        .finally(() => (this.loading = false));
    },
    back() {
      this.$router.push({ name: 'NotifIndex' });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background-color: #00BF63;
    border-radius: 8px 8px 0 0;
    background: #00BF63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.text-quiz-bottom {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
